/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';
import type { ProfileDto } from './ProfileDto';
import {
    ProfileDtoFromJSON,
    ProfileDtoFromJSONTyped,
    ProfileDtoToJSON,
    ProfileDtoToJSONTyped,
} from './ProfileDto';

/**
 * 
 * @export
 * @interface ProfileListResponse
 */
export interface ProfileListResponse {
    /**
     * 
     * @type {Array<ProfileDto>}
     * @memberof ProfileListResponse
     */
    data?: Array<ProfileDto>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof ProfileListResponse
     */
    pagination?: PaginationInfo;
}

/**
 * Check if a given object implements the ProfileListResponse interface.
 */
export function instanceOfProfileListResponse(value: object): value is ProfileListResponse {
    return true;
}

export function ProfileListResponseFromJSON(json: any): ProfileListResponse {
    return ProfileListResponseFromJSONTyped(json, false);
}

export function ProfileListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfileListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(ProfileDtoFromJSON)),
        'pagination': json['pagination'] == null ? undefined : PaginationInfoFromJSON(json['pagination']),
    };
}

export function ProfileListResponseToJSON(json: any): ProfileListResponse {
    return ProfileListResponseToJSONTyped(json, false);
}

export function ProfileListResponseToJSONTyped(value?: ProfileListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(ProfileDtoToJSON)),
        'pagination': PaginationInfoToJSON(value['pagination']),
    };
}

